export const CHECKOUT_ABANDON_ORDER = 'checkout_abandon_order';
export const CHECKOUT_GET_ATTENDEES = 'checkout_get_attendees';
export const CHECKOUT_SET_ATTENDEES = 'checkout_set_attendees';
export const CHECKOUT_GET_ORDER = 'checkout_get_order';
export const CHECKOUT_PAYMENTS_BRAINTREE_CLIENT_TOKEN =
    'checkout_payments_braintree_client_token';
export const CHECKOUT_PAYMENTS_BRAINTREE_NONCE =
    'checkout_payments_braintree_nonce';
export const CHECKOUT_EVENTS_ORDER_PAYMENTS_OPTIONS =
    'checkout_events_order_payments_options';
export const CHECKOUT_EVENTS_UNITS_STATUS = 'checkout_events_units_status';
export const CHECKOUT_ORDERS_EMAIL_PREFERENCES =
    'checkout_orders_email_preferences';
export const CHECKOUT_GET_EVENTS_SPEC = 'checkout_get_events_spec';
export const CHECKOUT_CREATE_ORDER = 'checkout_create_order';
export const CHECKOUT_PLACE_ORDER = 'checkout_place_order';
export const CHECKOUT_EVENTS_TICKETS_CLASSES_FOR_SALE =
    'checkout_events_tickets_classes_for_sale';
export const CHECKOUT_USERS_VAULT_INSTRUMENTS =
    'checkout_users_vault_instruments';
export const CHECKOUT_USERS_ME = 'checkout_users_me';
export const CHECKOUT_USERS_LOOKUP = 'checkout_users_lookup';
export const CHECKOUT_UPDATE_ORDER = 'checkout_update_order';
export const CHECKOUT_ORDERS_ELEGIBILITY = 'checkout_orders_eligibility';
export const CHECKOUT_RESERVED_PICK_WIDGET = 'checkout_reserved_pick_widget';
export const CHECKOUT_EVENTS_EVENT_INFO = 'checkout_events_event_info';
export const CHECKOUT_EXPRESS_CHECKOUT_CONDITIONS =
    'checkout_express_checkout_conditions';

export const CHECKOUT_CORE_RESILIENCY_ACTIONS = [
    CHECKOUT_ABANDON_ORDER,
    CHECKOUT_GET_ATTENDEES,
    CHECKOUT_SET_ATTENDEES,
    CHECKOUT_GET_ORDER,
    CHECKOUT_PAYMENTS_BRAINTREE_CLIENT_TOKEN,
    CHECKOUT_PAYMENTS_BRAINTREE_NONCE,
    CHECKOUT_EVENTS_ORDER_PAYMENTS_OPTIONS,
    CHECKOUT_EVENTS_UNITS_STATUS,
    CHECKOUT_ORDERS_EMAIL_PREFERENCES,
    CHECKOUT_GET_EVENTS_SPEC,
    CHECKOUT_CREATE_ORDER,
    CHECKOUT_PLACE_ORDER,
    CHECKOUT_EVENTS_TICKETS_CLASSES_FOR_SALE,
    CHECKOUT_USERS_VAULT_INSTRUMENTS,
    CHECKOUT_USERS_ME,
    CHECKOUT_USERS_LOOKUP,
    CHECKOUT_UPDATE_ORDER,
    CHECKOUT_ORDERS_ELEGIBILITY,
    CHECKOUT_RESERVED_PICK_WIDGET,
    CHECKOUT_EVENTS_EVENT_INFO,
    CHECKOUT_EXPRESS_CHECKOUT_CONDITIONS,
] as const;

export type CheckoutCoreResiliencyActionName =
    typeof CHECKOUT_CORE_RESILIENCY_ACTIONS[number];

let treatments: Record<string, boolean> = {};

export const setTreatments = (
    newTreatments: Record<CheckoutCoreResiliencyActionName, boolean>,
) => {
    treatments = newTreatments;
};

export const shouldServeActionFromBff = (
    actionName: CheckoutCoreResiliencyActionName,
): boolean => treatments[actionName] ?? true;
